import Services from '../../services';

class BayarDPVendor {
  // API SERVER
  get(params) {
    return Services.get('hrdu/approval_mutasi/list', { params });
  }

  getHistory(params) {
    return Services.get('hrdu/approval_mutasi/history/list', { params });
  }

  getSingle(params) {
    return Services.get('hrdu/approval_mutasi/detail', { params });
  }

  approve(data) {
    return Services.post('hrdu/approval_mutasi/approve', data);
  }
}

export default new BayarDPVendor();
